import { create } from 'zustand'

interface ThemeState {
  theme: 'dark' | 'light'
  toggleTheme: () => void
  /**
   * `persist: false` applies the theme to this tab only, leaving the user's
   * saved preference alone — used where the theme is imposed by the context
   * (e.g. embedded in a host application) rather than chosen by the user.
   */
  setTheme: (theme: 'dark' | 'light', persist?: boolean) => void
}

function savedTheme(): 'dark' | 'light' | null {
  try {
    const v = localStorage.getItem('twastaTheme')
    return v === 'dark' || v === 'light' ? v : null
  } catch {
    return null
  }
}

export const useThemeStore = create<ThemeState>((set) => ({
  // Light by default: a user with no saved choice opens in light. A saved
  // choice (the user-menu Light/Dark switch) always wins.
  theme: savedTheme() || 'light',

  toggleTheme: () =>
    set((state) => {
      const newTheme = state.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('twastaTheme', newTheme)
      document.body.className = newTheme === 'light' ? 'light-theme' : ''
      return { theme: newTheme }
    }),

  setTheme: (theme, persist = true) => {
    if (persist) localStorage.setItem('twastaTheme', theme)
    document.body.className = theme === 'light' ? 'light-theme' : ''
    set({ theme })
  },
}))
